import React, { useState } from "react";
import { PiStarFill } from "react-icons/pi";
import { RiSecurePaymentFill } from "react-icons/ri";
import { CiLocationOn } from "react-icons/ci";
import { RiCoupon3Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";

export default function Checkout1() {
  const [currentStep, setCurrentStep] = useState(1);

  const handleContinueReview = () => {
    setCurrentStep(2);
  };
  return (
    <>
      {/* Navbar with Progress Steps */}
      {/* Navbar with Progress Steps */}
      <div className="max-w-6xl mx-auto py-4">
        <div className="flex items-center justify-between mx-4 relative">
          {/* Step 1 */}
          <div className="flex flex-col items-center">
            <div
              className={`w-6 h-6 flex items-center justify-center rounded-full ${
                currentStep === 1
                  ? "bg-black text-white"
                  : "bg-gray-300 text-black"
              }`}
            >
              1
            </div>
            <p className="text-sm mt-1">Cart</p>
          </div>

          {/* Dotted Line */}
          <div className="flex-1 border-dotted border-t-2 border-gray-400 mx-2"></div>

          {/* Step 2 */}
          <div className="flex flex-col items-center">
            <div
              className={`w-6 h-6 flex items-center justify-center rounded-full ${
                currentStep === 2
                  ? "bg-black text-white"
                  : "bg-gray-300 text-black"
              }`}
            >
              2
            </div>
            <p className="text-sm mt-1">Delivery</p>
          </div>

          {/* Dotted Line */}
          <div className="flex-1 border-dotted border-t-2 border-gray-400 mx-2"></div>

          {/* Step 3 */}
          <div className="flex flex-col items-center">
            <div
              className={`w-6 h-6 flex items-center justify-center rounded-full ${
                currentStep === 3
                  ? "bg-black text-white"
                  : "bg-gray-300 text-black"
              }`}
            >
              3
            </div>
            <p className="text-sm mt-1">Payment</p>
          </div>
        </div>
      </div>

      <div className="max-w-full mx-auto p-4 bg-white">
        {/* Cart Heading */}
        <h1 className="text-2xl font-bold">Checkout</h1>

        {/* Main Layout: Cart Items on Left & Order Summary on Right */}
        <div className="flex flex-col lg:flex-row justify-between mt-4">
          {/* Left Side - Cart Items */}
          <div className="w-full lg:w-2/3 space-y-4">
            {currentStep === 1 && (
              <>
                <form className="bg-white  p-4 rounded-lg">
                  {/* ... your input fields for first name, last name, etc. */}
                  <h2 className="text-xl font-semibold mb-5">
                    Personal Details
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* First Name */}
                    <div>
                      <label className="text-gray-600 text-sm">
                        First Name
                      </label>
                      <input
                        type="text"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="Enter First Name"
                      />
                    </div>
                    {/* Last Name */}
                    <div>
                      <label className="text-gray-600 text-sm">Last Name</label>
                      <input
                        type="text"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="Enter Last Name"
                      />
                    </div>
                    {/* Mobile Number */}
                    <div>
                      <label className="text-gray-600 text-sm">
                        Mobile Number
                      </label>
                      <input
                        type="text"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="Enter Mobile Number"
                      />
                    </div>
                    {/* Email ID */}
                    <div>
                      <label className="text-gray-600 text-sm">Email ID</label>
                      <input
                        type="email"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="Enter Email ID"
                      />
                    </div>
                    {/* Anniversary Date */}
                    <div>
                      <label className="text-gray-600 text-sm">
                        Anniversary
                      </label>
                      <input
                        type="date"
                        className="w-full border rounded p-3 mt-1"
                      />
                    </div>
                    {/* Date of Birth */}
                    <div>
                      <label className="text-gray-600 text-sm">
                        Date of Birth
                      </label>
                      <input
                        type="date"
                        className="w-full border rounded p-3 mt-1"
                      />
                    </div>
                  </div>
                  <div className="mt-3">
                    <label className="text-gray-600 text-sm">
                      By continuing, I agree to the{" "}
                      <span className="underline">
                        Terms of Use & Privacy Policy
                      </span>
                    </label>
                  </div>
                  <h2 className="text-xl font-semibold mt-5 mb-5">
                    Delivery Address
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* First Name */}
                    <div>
                      <label className="text-gray-600 text-sm">
                        First Name
                      </label>
                      <input
                        type="text"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="Enter First Name"
                      />
                    </div>
                    {/* Last Name */}
                    <div>
                      <label className="text-gray-600 text-sm">Last Name</label>
                      <input
                        type="text"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="Enter Last Name"
                      />
                    </div>
                    {/* Mobile Number */}
                    <div>
                      <label className="text-gray-600 text-sm">
                        Mobile Number
                      </label>
                      <input
                        type="text"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="Enter Mobile Number"
                      />
                    </div>
                    {/* Email ID */}
                    <div>
                      <label className="text-gray-600 text-sm">PinCode</label>
                      <input
                        type="email"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="PinCode"
                      />
                    </div>
                    <div className="col-span-1 md:col-span-2">
                      <label className="text-gray-600 text-sm">
                        House/Flat Number
                      </label>
                      <input
                        type="text"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="Enter House/Flat Number"
                      />
                    </div>
                    <div className="col-span-1 md:col-span-2">
                      <label className="text-gray-600 text-sm">
                        Area/Building Name
                      </label>
                      <input
                        type="text"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="Area/Building Name"
                      />
                    </div>
                    <div className="col-span-1 md:col-span-2">
                      <label className="text-gray-600 text-sm">Landmark</label>
                      <input
                        type="text"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="Landmark"
                      />
                    </div>
                    <div>
                      <label className="text-gray-600 text-sm">City</label>
                      <input
                        type="text"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="Enter City Name"
                      />
                    </div>
                    <div>
                      <label className="text-gray-600 text-sm">State</label>
                      <input
                        type="text"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="Enter State Name"
                      />
                    </div>

                    {/* Save As Section */}
                    <div className="col-span-1 md:col-span-2">
                      <label className="text-gray-600 text-sm">Save as</label>
                      <div className="flex space-x-3 mt-2">
                        <button className="flex items-center space-x-2 border px-4 py-2 rounded-full shadow-md focus:ring-2 focus:ring-black">
                          <span>🏠</span>
                          <span className="font-medium">Home</span>
                        </button>
                        <button className="flex items-center space-x-2 border px-4 py-2 rounded-full shadow-md focus:ring-2 focus:ring-black">
                          <span>💼</span>
                          <span className="font-medium">Office</span>
                        </button>
                        <button className="flex items-center space-x-2 border px-4 py-2 rounded-full shadow-md focus:ring-2 focus:ring-black">
                          <span>📍</span>
                          <span className="font-medium">Others</span>
                        </button>
                      </div>
                    </div>

                    {/* Checkbox for Billing Address */}
                    <div className="col-span-1 md:col-span-2 flex items-center space-x-2 mt-3">
                      <input
                        type="checkbox"
                        id="billingAddress"
                        className="w-5 h-5 border-gray-400"
                      />
                      <label htmlFor="billingAddress" className="text-gray-700">
                        Billing address is same as delivery address
                      </label>
                    </div>
                  </div>

                  <h2 className="text-xl font-semibold mt-5 mb-5">
                    Billing Address
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* First Name */}
                    <div>
                      <label className="text-gray-600 text-sm">
                        First Name
                      </label>
                      <input
                        type="text"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="Enter First Name"
                      />
                    </div>
                    {/* Last Name */}
                    <div>
                      <label className="text-gray-600 text-sm">Last Name</label>
                      <input
                        type="text"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="Enter Last Name"
                      />
                    </div>
                    {/* Mobile Number */}
                    <div>
                      <label className="text-gray-600 text-sm">
                        Mobile Number
                      </label>
                      <input
                        type="text"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="Enter Mobile Number"
                      />
                    </div>
                    {/* Email ID */}
                    <div>
                      <label className="text-gray-600 text-sm">PinCode</label>
                      <input
                        type="email"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="PinCode"
                      />
                    </div>
                    <div className="col-span-1 md:col-span-2">
                      <label className="text-gray-600 text-sm">
                        House/Flat Number
                      </label>
                      <input
                        type="text"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="Enter House/Flat Number"
                      />
                    </div>
                    <div className="col-span-1 md:col-span-2">
                      <label className="text-gray-600 text-sm">
                        Area/Building Name
                      </label>
                      <input
                        type="text"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="Area/Building Name"
                      />
                    </div>
                    <div className="col-span-1 md:col-span-2">
                      <label className="text-gray-600 text-sm">Landmark</label>
                      <input
                        type="text"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="Landmark"
                      />
                    </div>
                    <div>
                      <label className="text-gray-600 text-sm">City</label>
                      <input
                        type="text"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="Enter City Name"
                      />
                    </div>
                    <div>
                      <label className="text-gray-600 text-sm">State</label>
                      <input
                        type="text"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="Enter State Name"
                      />
                    </div>

                    <div className="col-span-1 md:col-span-2">
                      <label className="text-gray-600 text-sm font-semibold">
                        Is the delivery for you or someone else?
                      </label>
                      <div className="flex items-center space-x-4 mt-2">
                        {/* Radio Button for "Myself" */}
                        <label className="flex items-center space-x-2">
                          <input
                            type="radio"
                            name="deliveryFor"
                            value="myself"
                            className="w-4 h-4 accent-black"
                          />
                          <span className="text-gray-500">Myself</span>
                        </label>

                        {/* Radio Button for "For someone else" */}
                        <label className="flex items-center space-x-2">
                          <input
                            type="radio"
                            name="deliveryFor"
                            value="someoneElse"
                            className="w-4 h-4 accent-black"
                            defaultChecked
                          />
                          <span className="font-semibold text-black">
                            For someone else
                          </span>
                        </label>
                      </div>
                    </div>
                    <div>
                      <label className="text-gray-600 text-sm">
                        Alternate Mobile Number
                      </label>
                      <input
                        type="text"
                        className="w-full border rounded p-3 mt-1"
                        placeholder="Enter Alternate Mobile Number"
                      />
                    </div>
                  </div>

                  {/* Continue Button */}
                  {/* <button
                    type="button"
                    onClick={handleContinueReview}
                    className="w-full bg-black text-white font-semibold py-2 mt-4 rounded-lg"
                  >
                    Continue to Review
                  </button> */}
                </form>
              </>
            )}

            {currentStep === 2 && (
              <>
                <h2 className="text-xl font-semibold">Payment Information</h2>
                <form className="bg-white border p-4 rounded-lg">
                  {/* Payment form fields (e.g., card number, expiry, cvv, etc.) */}
                  <div className="mb-4">
                    <label className="text-gray-600 text-sm">Card Number</label>
                    <input
                      type="text"
                      className="w-full border rounded p-2 mt-1"
                      placeholder="Enter Card Number"
                    />
                  </div>
                  <div className="mb-4">
                    <label className="text-gray-600 text-sm">Expiry Date</label>
                    <input
                      type="text"
                      className="w-full border rounded p-2 mt-1"
                      placeholder="MM/YY"
                    />
                  </div>
                  <div className="mb-4">
                    <label className="text-gray-600 text-sm">CVV</label>
                    <input
                      type="password"
                      className="w-full border rounded p-2 mt-1"
                      placeholder="Enter CVV"
                    />
                  </div>
                  {/* Add more payment related fields if needed */}
                  <button className="w-full bg-black text-white font-semibold py-2 mt-4 rounded-lg">
                    Proceed to Payment
                  </button>
                </form>
              </>
            )}
          </div>

          {/* Right Side - Order Summary */}
          <div className="w-full lg:w-1/3 lg:ml-4 lg:mt-0">
            {/* Apply Coupon */}
            <div className="bg-white mb-3 rounded-lg p-1 text-start flex items-center justify-between border">
              <div className="flex items-center">
                <RiCoupon3Line className="mr-2 text-lg" />
                <h3 className="text-sm mt-2">Apply Coupon Code</h3>
              </div>
              <MdKeyboardArrowRight className="text-xl" />
            </div>

            <div className="bg-white border p-4">
              <h3 className="font-semibold text-lg">Order Summary</h3>

              <div className="flex justify-between text-gray-700 mt-2">
                <p>Price (1 item)</p>
                <p>
                  <span className="line-through text-gray-500">₹69,900</span>{" "}
                  ₹63,900
                </p>
              </div>

              <div className="flex justify-between text-gray-700 mt-2">
                <p>
                  Delivery Charges{" "}
                  <span className="text-white bg-green-500 p-1 rounded-full text-xs px-2">
                    Free
                  </span>
                </p>
                <p>₹160</p>
              </div>

              <div className="bg-gray-200 p-2 rounded-lg mt-4 text-lg">
                You will save <span className="text-green-600"> ₹6,000</span> on
                this order
              </div>

              <div className="flex justify-between text-xl font-semibold mt-4 border-t border-gray-500 p-2">
                <p>To Pay</p>
                <p>₹63,900</p>
              </div>
            </div>

            {/* Delivery Address */}
            <div className="bg-white mt-3 border p-1 py-0 flex items-center text-start">
              <CiLocationOn className="text-red-500 w-6 h-6 mr-2" />
              <p className="mt-3">
                Deliver to <span className="font-semibold">Pune 411045</span>{" "}
                <span className="text-blue-500 cursor-pointer">
                  Change Location
                </span>
              </p>
            </div>

            <div className="mt-3 text-start">
              <p className="font-semibold">
                I have a GST Number{" "}
                <span className="font-normal">(If applicable)</span>
              </p>

              <div className="flex justify-between items-center border border-gray-400 rounded-md px-3 py-2 mt-2 bg-white">
                <input
                  type="text"
                  placeholder="Enter GST Number"
                  className="w-full outline-none"
                />
                <a href="#" className="text-black font-semibold ml-2">
                  Apply
                </a>
              </div>

              <button
              type="button"
              onClick={handleContinueReview}
              className="w-full bg-black text-white font-semibold py-2.5 mt-4 rounded-full"
              >
                Proceed to Checkout
              </button>
            </div>

            <div className="mt-3 text-start bg-white">
              <div className="grid grid-cols-1 md:grid-cols-2 px-3">
                <div className="flex items-center">
                  <RiSecurePaymentFill className="text-black text-5xl mr-3" />
                  <div className="py-0 mt-3">
                    <p className="font-semibold text-sm">
                      Trusted by Thousands
                    </p>
                  </div>
                </div>

                <div className="flex items-center">
                  <PiStarFill className="text-black text-5xl mr-3" />
                  <p className="text-sm font-semibold mt-3">
                    Trusted by Thousands
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
